import {calcTotalPrice, nextRowId, normalizePrice} from "src/utils/quote";
import {convertFromTo} from "src/utils/convertPrice";
import {
  deepCopy,
  supportedCurrencies,
  toastError,
  toastInfoSingle
} from "src/utils/controllerAdapterForOfferPage";
import {ts} from "src/utils/translate";
import $ from 'jquery'
import {
  INTERNAL_MANUFACTURER_KEY,
  USER_MANUFACTURER_KEY
} from "src/utils/manufacturerUtil";

const ROOM_TABLE = "roomtable"
const PROJECT_CUSTOM_TABLE = "projectcustomtable"
const FUNCTION_TABLE = "functiontable"
const NHC_DIN_TABLE = "nhcdintable"
const RACK_TABLE = "racktable"
const PROJECT_CABLE_TABLE = "projectcablestable"
const CONV_FUNCTION_TABLE = "convfunctiontable"
const SECTION_TABLE = "sectiontable"

export const sendCustomItem = async (
    customItem,
    entityType,
    entityId,
    currency,
    setCustomRowButtonPressed,
    setSuccessResponse,
    addRoomCustomItem,
    addProjectCustomItem,
    addElectricalCustomItem,
    addNhcCustomItem,
    addCustomSectionItem,
) => {
  let addItemFn;
  const requestData = {
    short_description: customItem.product_name,
    quantity: customItem.quantity,
    custom_description: customItem.custom_description,
    article_number: customItem.article_number,
  };

  switch (entityType) {
    case ROOM_TABLE:
      requestData.room_id = entityId;
      addItemFn = addRoomCustomItem;
      break;

    case PROJECT_CUSTOM_TABLE:
      requestData.project_id = entityId;
      addItemFn = addProjectCustomItem;
      break;

    case FUNCTION_TABLE:
      requestData.project_id = entityId;
      addItemFn = addElectricalCustomItem;
      break;

    case NHC_DIN_TABLE:
      requestData.project_id = entityId;
      addItemFn = addNhcCustomItem;
      break;

    case SECTION_TABLE:
      requestData.section_id = entityId;
      addItemFn = addCustomSectionItem;
      break;
  }

  const price = normalizePrice(customItem.net_price);
  const priceInAllCurrencies = supportedCurrencies.map((curr) => {
    return {
      currency: curr,
      value: convertFromTo(price, currency, curr),
    };
  });

  priceInAllCurrencies.forEach((price) => {
    requestData["price_" + price.currency] = price.value;
  });

  if (customItem[INTERNAL_MANUFACTURER_KEY]) {
    requestData[INTERNAL_MANUFACTURER_KEY] =
        customItem[INTERNAL_MANUFACTURER_KEY];
  } else if (customItem[USER_MANUFACTURER_KEY]) {
    requestData[USER_MANUFACTURER_KEY] = customItem[USER_MANUFACTURER_KEY];
  }

  if (
      customItem.product_name === undefined ||
      !customItem.product_name.trim().length
  ) {
    toastInfoSingle(
        ts('q_custom_name_please', 'Please enter a name for your custom item')
    );
    const nameCell = $("#product_name");
    nameCell.trigger("focus");
  } else if (!(price && price > 0)) {
    toastInfoSingle(
        ts('q_custom_price_please', 'Please enter a price for your custom item')
    );
    const priceCell = $("#net_price");
    priceCell.trigger("focus");
  } else if (
      customItem.manufacturer_name &&
      customItem.manufacturer_name.length &&
      !customItem[INTERNAL_MANUFACTURER_KEY] &&
      !customItem[USER_MANUFACTURER_KEY]
  ) {
    toastInfoSingle(
        ts(
            "q_empty_or_valid_pls",
            "Please leave the manufacturer empty or select a value from the list"
        )
    );
    const manufacturerCell = $("#manufacturer_name");
    manufacturerCell.trigger("focus");
  } else {
    await addItemFn(requestData).then(response => {
      setSuccessResponse(response);
      setCustomRowButtonPressed(false);
    })
  }
};

export const sendFetchedItem = (
    fetchedItem,
    entityType,
    entityId,
    setCustomRowButtonPressed,
    setSuccessResponse,
    addRoomCustomItem,
    addProjectCustomItem,
    addElectricalCustomItem,
    addNhcCustomItem,
    addRackCabinetCustomItem,
    addCableCustomItem,
    addConventionalDevicesCustomItem,
    addCustomSectionItem
) => {
  return new Promise(async (res, rej) => {
    let addItemFn;
    let requestData = {
      quantity: fetchedItem.quantity,
      product_id: fetchedItem.product_id,
      article_number: fetchedItem.article_number
    };

    if (entityType !== NHC_DIN_TABLE) {
      requestData.custom_description = fetchedItem.custom_description;
    }

    if (entityType === ROOM_TABLE) {
      requestData.room_id = entityId;
    } else if (entityType === SECTION_TABLE) {
      requestData.section_id = entityId;
    } else {
      requestData.project_id = entityId;
    }

    switch (entityType) {
      case ROOM_TABLE:
        addItemFn = addRoomCustomItem;
        break;
      case PROJECT_CUSTOM_TABLE:
        addItemFn = addProjectCustomItem;
        break;
      case FUNCTION_TABLE:
        addItemFn = addElectricalCustomItem;
        break;
      case NHC_DIN_TABLE:
        addItemFn = addNhcCustomItem;
        break;
      case RACK_TABLE:
        addItemFn = addRackCabinetCustomItem;
        break;
      case PROJECT_CABLE_TABLE:
        addItemFn = addCableCustomItem;
        break;
      case CONV_FUNCTION_TABLE:
        addItemFn = addConventionalDevicesCustomItem;
        break;
      case SECTION_TABLE:
        addItemFn = addCustomSectionItem;
        break;
    }

    await addItemFn(requestData).then(response => {
      setSuccessResponse(response);
      setCustomRowButtonPressed(false);
    })

  });
};

export const deleteCustomItem = async (
    rowData,
    rowIsIn,
    deleteRoomCustomItem,
    deleteProjectCustomItem,
    deleteElectricalCustomItem,
    deleteNhcCustomItem,
    deleteCustomSectionItem,
    deleteRackCabinetCustomItem,
    deleteCableCustomItem,
    deleteConventionalDevicesCustomItem,
) => {
  let requestData, deleteItemFn;

  if (rowIsIn === ROOM_TABLE) {
    requestData = {room_custom_item_id: rowData.custom_item_id};
    deleteItemFn = deleteRoomCustomItem;
  } else if (rowIsIn === PROJECT_CUSTOM_TABLE) {
    requestData = {project_custom_item_id: rowData.custom_item_id};
    deleteItemFn = deleteProjectCustomItem;
  } else if (rowIsIn === FUNCTION_TABLE) {
    requestData = {electrical_cabinet_custom_item_id: rowData.custom_item_id};
    deleteItemFn = deleteElectricalCustomItem;
  } else if (rowIsIn === NHC_DIN_TABLE) {
    requestData = {nhc_custom_item_id: rowData.custom_item_id};
    deleteItemFn = deleteNhcCustomItem;
  } else if (rowIsIn === SECTION_TABLE) {
    requestData = {section_item_id: rowData.custom_section_item_id};
    deleteItemFn = deleteCustomSectionItem;
  } else if (rowIsIn === RACK_TABLE) {
    requestData = {rack_cabinet_custom_item_id: rowData.custom_item_id};
    deleteItemFn = deleteRackCabinetCustomItem;
  } else if (rowIsIn === PROJECT_CABLE_TABLE) {
    requestData = {cable_custom_item_id: rowData.custom_item_id};
    deleteItemFn = deleteCableCustomItem;
  } else if (rowIsIn === CONV_FUNCTION_TABLE) {
    requestData = {conventional_devices_custom_item_id: rowData.custom_item_id};
    deleteItemFn = deleteConventionalDevicesCustomItem;
  }
  if (requestData && deleteItemFn) {
    await deleteItemFn(requestData).then(
        response => {
        },
        response => {
          if (response.responseJSON && response.responseJSON.message) {
            toastError(response.responseJSON.message);
          }
        });
  }
  // });
};

export const modifyCustomItem = async (
    row,
    entityType,
    currency,
    setSuccessResponse,
    modifyMode,
    setModifyMode,
    modifyRow,
    setModifyRow,
    updateRoomCustomItem,
    updateProjectCustomItem,
    updateElectricalCustomItem,
    updateNhcCustomItem,
    updateCustomSectionItem,
) => {
  let updateItemFn;
  const requestData = {
    short_description: row.product_name,
    quantity: row.quantity,
    custom_description: row.custom_description,
    article_number: row.article_number,
    manufacturer_name: row.manufacturer_name
  };

  const price = normalizePrice(row.net_price);
  const priceInAllCurrencies = supportedCurrencies.map((curr) => {
    return {
      currency: curr,
      value: convertFromTo(price, currency, curr),
    };
  });

  priceInAllCurrencies.forEach((price) => {
    requestData["price_" + price.currency] = price.value;
  });

  const manufacturerCell = $("#manufacturer_name");

  if (
      row[INTERNAL_MANUFACTURER_KEY] &&
      (!row[USER_MANUFACTURER_KEY] || row[USER_MANUFACTURER_KEY] === "") &&
      manufacturerCell.val() !== ""
  ) {
    requestData[INTERNAL_MANUFACTURER_KEY] =
        row[INTERNAL_MANUFACTURER_KEY];
  } else if (
      row[USER_MANUFACTURER_KEY] &&
      (!row[INTERNAL_MANUFACTURER_KEY] ||
          row[INTERNAL_MANUFACTURER_KEY] === "") &&
      manufacturerCell.val() !== ""
  ) {
    requestData[USER_MANUFACTURER_KEY] = row[USER_MANUFACTURER_KEY];
  } else if (
      row[INTERNAL_MANUFACTURER_KEY] &&
      row[USER_MANUFACTURER_KEY] &&
      manufacturerCell.val() !== ""
  ) {
    if (row["user_manufacturer_name"] !== "") {
      requestData[INTERNAL_MANUFACTURER_KEY] =
          row[INTERNAL_MANUFACTURER_KEY];
      requestData[USER_MANUFACTURER_KEY] = "";
    } else {
      requestData[USER_MANUFACTURER_KEY] = row[USER_MANUFACTURER_KEY];
      requestData[INTERNAL_MANUFACTURER_KEY] = "";
    }
  } else if (entityType !== PROJECT_CUSTOM_TABLE) {
    requestData['manufacturer_name'] = 'ETC'
    requestData[INTERNAL_MANUFACTURER_KEY] = 6;
    requestData[USER_MANUFACTURER_KEY] = "";
  }

  switch (entityType) {
    case ROOM_TABLE:
      requestData.room_custom_item_id = row.custom_item_id;
      updateItemFn = updateRoomCustomItem;
      break;

    case PROJECT_CUSTOM_TABLE:
      requestData.project_custom_item_id = row.custom_item_id;
      updateItemFn = updateProjectCustomItem;
      break;

    case FUNCTION_TABLE:
      requestData.electrical_custom_item_id = row.custom_item_id;
      updateItemFn = updateElectricalCustomItem;
      break;

    case SECTION_TABLE:
      requestData.section_item_id = row.custom_section_item_id;
      updateItemFn = updateCustomSectionItem;
      break;
    case NHC_DIN_TABLE:
      requestData.nhc_custom_item_id = row.custom_item_id;
      updateItemFn = updateNhcCustomItem;
      break;
  }

  if (row.product_name === undefined || !row.product_name.trim().length) {
    toastInfoSingle(
        ts("modify_custom_item", "Please enter a name for your custom item")
    );
    const nameCell = $("#product_name");
    nameCell.trigger("focus");
  } else if (!(price && price > 0)) {
    toastInfoSingle(
        ts("q_custom_price_please", "Please enter a price for your custom item")
    );
    const priceCell = $("#net_price");
    priceCell.trigger("focus");
  } else if (
      row.manufacturer_name &&
      row.manufacturer_name.length &&
      !row[INTERNAL_MANUFACTURER_KEY] &&
      !row[USER_MANUFACTURER_KEY]
  ) {
    toastInfoSingle(
        ts(
            "q_empty_or_valid_pls",
            "Please leave the manufacturer empty or select a value from the list"
        )
    );
    manufacturerCell.trigger("focus");
  } else {
    await updateItemFn(requestData).then(
        response => {
          setSuccessResponse(response);
          if (modifyRow) {
            setModifyRow(false);
          }
          if (modifyMode) {
            setModifyMode(false);
          }
          return response;
        },
        response => {
          if (response.responseJSON && response.responseJSON.message) {
            toastError(response.responseJSON.message);
          }
          return response;
        }
    )
  }
};

export const modifyFetchedItem = (
    fetchedItem,
    entityType,
    setSuccessResponse,
    modifyMode,
    setModifyMode,
    modifyRow,
    setModifyRow,
    updateRoomCustomItem,
    updateProjectCustomItem,
    updateElectricalCustomItem,
    updateNhcCustomItem,
    updateRackCabinetCustomItem,
    updateCableCustomItem,
    updateConventionalDevicesCustomItem,
    updateCustomSectionItem,
) => {
  return new Promise(async (res, rej) => {
    let updateItemFn;
    const requestData = {
      short_description: fetchedItem.product_name,
      quantity: fetchedItem.quantity,
      product_id: fetchedItem.product_id,
    };

    if (entityType !== NHC_DIN_TABLE) {
      requestData.custom_description = fetchedItem.custom_description;
      requestData.article_number = fetchedItem.article_number;
    }

    switch (entityType) {
      case ROOM_TABLE:
        requestData.room_custom_item_id = fetchedItem.custom_item_id;
        updateItemFn = updateRoomCustomItem;
        break;
      case PROJECT_CUSTOM_TABLE:
        requestData.project_custom_item_id = fetchedItem.custom_item_id;
        updateItemFn = updateProjectCustomItem;
        break;
      case FUNCTION_TABLE:
        requestData.electrical_custom_item_id = fetchedItem.custom_item_id;
        updateItemFn = updateElectricalCustomItem;
        break;
      case NHC_DIN_TABLE:
        requestData.nhc_custom_item_id = fetchedItem.custom_item_id;
        updateItemFn = updateNhcCustomItem;
        break;
      case RACK_TABLE:
        requestData.rack_cabinet_custom_item_id = fetchedItem.custom_item_id;
        updateItemFn = updateRackCabinetCustomItem;
        break;
      case PROJECT_CABLE_TABLE:
        requestData.cable_custom_item_id = fetchedItem.custom_item_id;
        updateItemFn = updateCableCustomItem;
        break;
      case CONV_FUNCTION_TABLE:
        requestData.conventional_devices_custom_item_id = fetchedItem.custom_item_id;
        updateItemFn = updateConventionalDevicesCustomItem;
        break;
      case SECTION_TABLE:
        requestData.section_item_id = fetchedItem.custom_section_item_id;
        updateItemFn = updateCustomSectionItem;
        break;
    }

    if (fetchedItem[INTERNAL_MANUFACTURER_KEY]) {
      requestData[INTERNAL_MANUFACTURER_KEY] =
          fetchedItem[INTERNAL_MANUFACTURER_KEY];
    } else if (fetchedItem[USER_MANUFACTURER_KEY]) {
      requestData[USER_MANUFACTURER_KEY] = fetchedItem[USER_MANUFACTURER_KEY];
    }

    await updateItemFn(requestData).then(
        response => {
          setSuccessResponse(response);
          if (modifyRow) {
            setModifyRow(false);
          }
          if (modifyMode) {
            setModifyMode(false);
          }
          return res();
        },
        response => {
          if (response.responseJSON && response.responseJSON.message) {
            toastError(response.responseJSON.message);
          }
          return rej();
        }
    )
  });
};

const insertMinusRow = async (
    row,
    entityType,
    entityId,
    currency,
    addRoomCustomItem,
    addProjectCustomItem,
    addElectricalCustomItem,
    addNhcCustomItem,
    addRackCabinetCustomItem,
    addCableCustomItem,
    addConventionalDevicesCustomItem,
    addCustomSectionItem,
) => {
  // return new Promise((res, rej) => {
  const newRow = Object.assign({}, row);

  newRow.custom = true;
  newRow.discount = 0;
  newRow.labour = 0;
  newRow.fetchedFromServer = true;
  newRow.rowType = ts('quote_custom', 'quoteCustom');
  newRow.DT_RowId = nextRowId();
  newRow.custom_item_id = +row.custom_item_id;
  newRow.quantity = -Math.abs(newRow.quantity);
  newRow.total_price = calcTotalPrice(
      newRow["price_" + currency] || 0,
      newRow.quantity,
      newRow.discount,
      newRow.labour
  );
  let addItemFn;
  let requestData = {
    quantity: newRow.quantity,
    product_id: newRow.product_id,
  }

  if (entityType !== NHC_DIN_TABLE) {
    requestData.custom_description = newRow.custom_description;
    requestData.article_number = newRow.article_number;
  }

  if (entityType === ROOM_TABLE) {
    requestData.room_id = entityId;
  } else if (entityType === SECTION_TABLE) {
    requestData.section_id = entityId;
  } else {
    requestData.project_id = entityId;
  }

  switch (entityType) {
    case ROOM_TABLE:
      addItemFn = addRoomCustomItem;
      break;
    case PROJECT_CUSTOM_TABLE:
      addItemFn = addProjectCustomItem;
      break;
    case FUNCTION_TABLE:
      addItemFn = addElectricalCustomItem;
      break;
    case NHC_DIN_TABLE:
      addItemFn = addNhcCustomItem;
      break;
    case RACK_TABLE:
      addItemFn = addRackCabinetCustomItem;
      break;
    case PROJECT_CABLE_TABLE:
      addItemFn = addCableCustomItem;
      break;
    case CONV_FUNCTION_TABLE:
      addItemFn = addConventionalDevicesCustomItem;
      break;
    case SECTION_TABLE:
      addItemFn = addCustomSectionItem;
      break;
  }

  await addItemFn(requestData)
  .then(
      response => {
        toastInfoSingle(
            ts(
                "q_minus_info",
                "A new row was added to cancel out the selected row."
            )
        );
      },
      response => {
        if (response.responseJSON && response.responseJSON.message) {
          toastError(response.responseJSON.message);
        }
      }
  )
};

export const addMinusRow = (
    row,
    entityType,
    entityId,
    currency,
    addRoomCustomItem,
    addProjectCustomItem,
    addElectricalCustomItem,
    addNhcCustomItem,
    addRackCabinetCustomItem,
    addCableCustomItem,
    addConventionalDevicesCustomItem,
    addCustomSectionItem,
) => {
  let clonedRowData = deepCopy(row);
  clonedRowData.quantity *= -1;

  insertMinusRow(
      clonedRowData,
      entityType,
      entityId,
      currency,
      addRoomCustomItem,
      addProjectCustomItem,
      addElectricalCustomItem,
      addNhcCustomItem,
      addRackCabinetCustomItem,
      addCableCustomItem,
      addConventionalDevicesCustomItem,
      addCustomSectionItem,
  );
};

export const addEditableMinusRow = (
    customItem,
    entityType,
    entityId,
    currency,
    originalQuantity,
    addRoomCustomItem,
    addProjectCustomItem,
    addElectricalCustomItem,
    addNhcCustomItem,
    addRackCabinetCustomItem,
    addCableCustomItem,
    addConventionalDevicesCustomItem,
    addCustomSectionItem,
) => {
  const newQuantity = Math.abs(+customItem.quantity);

  if (Number.isNaN(+newQuantity)) {
    toastInfoSingle(ts("jqval_msg_number", "Please enter a valid number."));
    return;
  }

  if (newQuantity === 0) {
    toastInfoSingle(
        ts(
            "jqval_msg_min",
            "Please enter a value greater than or equal to {0}."
        ).replace("{0}", 1)
    );
    return;
  }

  if (Math.abs(newQuantity) > Math.abs(originalQuantity)) {
    toastInfoSingle(
        ts(
            "q_max_minus",
            "At most, you can deduct the original quantity ({0})."
        ).replace("{0}", Math.abs(originalQuantity))
    );
    return;
  }

  insertMinusRow(
      customItem,
      entityType,
      entityId,
      currency,
      addRoomCustomItem,
      addProjectCustomItem,
      addElectricalCustomItem,
      addNhcCustomItem,
      addRackCabinetCustomItem,
      addCableCustomItem,
      addConventionalDevicesCustomItem,
      addCustomSectionItem,
  );
};

export const modifyMinusRow = async (
    row,
    entityType,
    currency,
    originalQuantity,
    setSuccessResponse,
    updateRoomCustomItem,
    updateProjectCustomItem,
    updateElectricalCustomItem,
    updateNhcCustomItem,
    updateRackCabinetCustomItem,
    updateCableCustomItem,
    updateConventionalDevicesCustomItem,
    updateCustomSectionItem,
) => {
  const newQuantity = Math.abs(+row.quantity);
  const quantityCell = $("#quantity");

  if (Number.isNaN(+newQuantity)) {
    toastInfoSingle(ts("jqval_msg_number", "Please enter a valid number."));
    quantityCell.trigger("focus");
    return;
  }

  if (newQuantity === 0) {
    toastInfoSingle(
        ts(
            "jqval_msg_min",
            "Please enter a value greater than or equal to {0}."
        ).replace("{0}", 1)
    );
    quantityCell.trigger("focus");
    return;
  }

  if (Math.abs(newQuantity) > Math.abs(originalQuantity)) {
    toastInfoSingle(
        ts(
            "q_max_minus",
            "At most, you can deduct the original quantity ({0})."
        ).replace("{0}", Math.abs(originalQuantity))
    );
    quantityCell.trigger("focus");
    return;
  }

  const newRow = Object.assign({}, row);

  newRow.custom = true;
  newRow.discount = 0;
  newRow.labour = 0;
  newRow.fetchedFromServer = true;
  newRow.rowType = ts('quote_custom', 'quoteCustom');
  newRow.DT_RowId = nextRowId();
  newRow.custom_item_id = +row.custom_item_id;
  newRow.quantity = -Math.abs(newRow.quantity);
  newRow.total_price = calcTotalPrice(
      newRow["price_" + currency] || 0,
      newRow.quantity,
      newRow.discount,
      newRow.labour
  );
  let updateItemFn;
  let requestData = {
    quantity: newRow.quantity,
    product_id: newRow.product_id,
    article_number: newRow.article_number,
  };

  if (entityType !== NHC_DIN_TABLE) {
    requestData.custom_description = newRow.custom_description;
  }

  switch (entityType) {
    case ROOM_TABLE:
      requestData.room_custom_item_id = newRow.custom_item_id;
      updateItemFn = updateRoomCustomItem;
      break;
    case PROJECT_CUSTOM_TABLE:
      requestData.project_custom_item_id = newRow.custom_item_id;
      updateItemFn = updateProjectCustomItem;
      break;
    case FUNCTION_TABLE:
      requestData.electrical_custom_item_id = newRow.custom_item_id;
      updateItemFn = updateElectricalCustomItem;
      break;
    case NHC_DIN_TABLE:
      requestData.nhc_custom_item_id = newRow.custom_item_id;
      updateItemFn = updateNhcCustomItem;
      break;
    case RACK_TABLE:
      requestData.rack_cabinet_custom_item_id = newRow.custom_item_id;
      updateItemFn = updateRackCabinetCustomItem;
      break;
    case PROJECT_CABLE_TABLE:
      requestData.cable_custom_item_id = newRow.custom_item_id;
      updateItemFn = updateCableCustomItem;
      break;
    case CONV_FUNCTION_TABLE:
      requestData.conventional_devices_custom_item_id = newRow.custom_item_id;
      updateItemFn = updateConventionalDevicesCustomItem;
      break;
    case SECTION_TABLE:
      requestData.section_item_id = newRow.custom_section_item_id;
      updateItemFn = updateCustomSectionItem;
      break;
  }

  await updateItemFn(requestData)
  .then(
      response => setSuccessResponse(response),
      response => {
        if (response.responseJSON && response.responseJSON.message) {
          toastError(response.responseJSON.message);
        }
      }
  )
};
